<template>
  <v-container fluid class="pa-1">
    <v-row align="start">
      <ReflectionCard
        v-for="item in unarchivedItems" :key="item.id"
        :item="item"
        :back-to="backTo"
      />
    </v-row>
    <v-btn
      class="my-4"
      elevation="0"
      v-if="archivedItems.length > 0"
      @click="toggleArchived"
    >
      {{ $t('views.reflection.showArchives') }}
    </v-btn>
    <v-row v-if="showArchived" align="start">
      <ReflectionCard
        back-to="reflections"
        v-for="item in archivedItems" :key="item.id"
        archived
        :item="item"
      />
    </v-row>
  </v-container>
</template>

<script>
import ReflectionCard from './ReflectionCard';

export default {
  name: 'ReflectionCardIterator',
  components: { ReflectionCard },
  props: {
    items: {
      type: Array,
      required: true,
    },
    backTo: {
      type: [String, Object],
      required: true,
    },
  },
  data() {
    return {
      showArchived: false,
      archivedItems: [],
      unarchivedItems: [],
    };
  },
  methods: {
    updateItems() {
      this.archivedItems = this.items.filter(item => item.isArchived);
      this.unarchivedItems = this.items.filter(item => !item.isArchived);
    },
    toggleArchived() {
      this.showArchived = !this.showArchived;
    },
  },
  mounted() {
    this.updateItems();
  },
  watch: {
    items() {
      console.log(this.items);
      this.updateItems();
    },
  },
};
</script>

<style scoped></style>
